__turbopack_context__.v({
  "cta": "SparseSectionPanel-module-scss-module__wXxssG__cta",
  "description": "SparseSectionPanel-module-scss-module__wXxssG__description",
  "icon": "SparseSectionPanel-module-scss-module__wXxssG__icon",
  "panel": "SparseSectionPanel-module-scss-module__wXxssG__panel",
  "title": "SparseSectionPanel-module-scss-module__wXxssG__title",
});
